import {Button} from '@mantine/core';
import type React from 'react';
import {MdOutlineRefresh} from 'react-icons/md';

type Props = {
  /** 次のページがあるかどうか */
  hasNextPage?: boolean;
  /** 次のページを取得する関数 */
  fetchNextPage: () => void;
  /** 次のページを取得中かどうか */
  isFetchingNextPage: boolean;
  /** すべてのデータを表示済みの場合のメッセージ */
  endMessage?: string;
};

/**
 * もっと見るボタンコンポーネント
 *
 * @description
 * ボタンをクリックすると次のページを読み込みます。
 */
export const LoadMoreButton: React.FC<Props> = ({
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  endMessage = 'すべてのデータを表示しました',
}) => {
  // 次のページがない場合は終了メッセージを表示
  if (!hasNextPage) {
    return (
      <div className="flex justify-center items-center py-16 text-sm text-gray-500">
        {endMessage}
      </div>
    );
  }

  // もっと見るボタンの表示
  return (
    <div className="flex justify-center items-center py-16">
      <Button
        variant="subtle"
        size="md"
        className="text-sm text-primary border border-primary rounded-16 hover:bg-primary/25"
        onClick={() => fetchNextPage()}
        loading={isFetchingNextPage}
        disabled={isFetchingNextPage}
      >
        <MdOutlineRefresh className="mr-2" size={16} />
        {isFetchingNextPage ? '読み込み中...' : 'もっと見る'}
      </Button>
    </div>
  );
};
